import Api from '../../../../../../shared/api';
import { locations as apiConfig } from '../../../../../config/api';
import {
  saveLocationsEntranceSuccess,
} from '../../../../../../shared/components/Locations/LocationsEntrance/LocationsEntrance.actions';

export const saveEntrance = (dispatch, action, entrance) => {
  const {
    entranceInletLockId,
    entranceInletOperation,
  } = action.payload;
  const exitingEntrance = !!entrance && entrance.attributes.type === 'lock' && !!entrance.attributes.config && entrance.attributes.config.provider === 'inlet' && entrance;

  return Api({
    method: exitingEntrance ? 'PATCH' : 'POST',
    path: `${apiConfig.path}/${action.id}${apiConfig.entrancePath}${exitingEntrance ? `/${exitingEntrance.id}` : ''}`,
    handle: r => r.send({
      attributes: {
        state: 'published',
        type: 'lock',
        config: {
          provider: 'inlet',
          inletLockId: entranceInletLockId,
          inletOperation: entranceInletOperation,
        }
      }
    })
  })
  .then(resp => dispatch(saveLocationsEntranceSuccess(resp, action.id)));
};
